<template>
  <div class="tab-table">
    <product-tab-tile
    v-for="prod in products"
    :key="prod.item_id"
    :product="prod"
    class="tab-tile"
    :class="{ 'active': prod.item_id === activeItemId }"
    @click.native="productSelected(prod, (prod.item_id === activeItemId))">
    </product-tab-tile>
  </div>
</template>

<script>
import ProductTabTile from 'theme/components/Checkout/PriceAdjustements/Tabs/Tile/ProductTabTile'

export default {
  name: 'ProductTab',
  props: {
    activeItemId: {
      type: String,
      default: () => false
    }
  },
  computed: {
    productAdjs () {
      return this.$store.getters['cart/getProductPriceAdj']
    },
    products () {
      return this.$store.state.cart.items
    }
  },
  methods: {
    productSelected (product, isActive) {
      // use isActive as toggle eventEmit
      product['final_price'] = product.row_total_incl_tax
      let selection = isActive ? '' : product
      return this.$emit('tile-selected', selection)
    }
  },
  components: {
    ProductTabTile
  }
}
</script>
